import {
  RenderContext
} from "../chunk-ALZ5FKDH.js";

// src/ssr/routing/routingResponse.ts
var ResponseType = /* @__PURE__ */ ((ResponseType2) => {
  ResponseType2[ResponseType2["SUCCESS"] = 0] = "SUCCESS";
  ResponseType2[ResponseType2["REDIRECT"] = 1] = "REDIRECT";
  ResponseType2[ResponseType2["CLIENT_ERROR"] = 2] = "CLIENT_ERROR";
  ResponseType2[ResponseType2["SERVER_ERROR"] = 3] = "SERVER_ERROR";
  return ResponseType2;
})(ResponseType || {});

// src/ssr/utils/getRouteContext.ts
import { useLoaderData, useLocation } from "react-router";
var fetchContext = async (args) => {
  const formattedUrl = args.request.url.split(/[?#]/)[0] || "";
  const contextUrl = formattedUrl.endsWith("/") ? `${formattedUrl}context.json` : `${formattedUrl}/context.json`;
  const isServerSide = typeof window === "undefined";
  const environment = isServerSide ? "SSR/ISR" : "Client";
  console.log(`[${environment}] FetchContext invoked for: ${contextUrl}`);
  try {
    const response = await fetch(contextUrl, { cache: "no-store" });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    console.log(`[${environment}] FetchContext success for: ${contextUrl}`);
    return {
      context: data
    };
  } catch (error) {
    if (isServerSide) {
      console.debug(
        `[${environment}] Expected context fetch failure (context.json not yet generated): ${contextUrl}`
      );
    } else {
      console.error(
        `[${environment}] Failed to fetch context from ${contextUrl}:`,
        error
      );
    }
    return { context: {} };
  }
};
var useRouteContext = () => {
  const location = useLocation();
  const loaderData = useLoaderData();
  if (!loaderData) {
    throw new Error(`Failed to get context for page "${location.pathname}"`);
  }
  return loaderData;
};
export {
  RenderContext,
  ResponseType,
  fetchContext,
  useRouteContext
};
//# sourceMappingURL=index.js.map
